import api from '@/libs/axios'

export default {
  getEnterprises: () => api.get('/system/project'),
  getEnterpriseById: id => api.get(`/system/project/${id}`),
  editEnterprise: form => api.patch(`/system/project/${form.id}`, form),
  createEnterprise: form => api.post('/system/project', form),
}
